import { useQuery } from "@apollo/react-hooks"
import { tokenContext } from "context/tokenContext"
import { userContext } from "context/User"
import preStayGet from "graphql/PMS/Stay/Pre/query/preStayGet"

import { getRootUrl } from "helpers/Utils"
import { PreStay, PreStaySendStatusEnum, UserRoleEnum } from "model"
import React, { useContext } from "react"

export type PreStayPreviewProps = {
  preStayId: string,
  // onSend?: () => void,
}


export const PreStayPreview = ({ preStayId }: PreStayPreviewProps) => {

  const { data } = useQuery<{ preStay: PreStay }>(preStayGet, {
    variables: {
      id: preStayId,
    },
    skip: !preStayId,
  })

  const { token } = useContext(tokenContext)


  const preStay = data?.preStay

  const user = useContext(userContext)
  const hasDebugRole = user.roles?.includes(UserRoleEnum.ROLE_DEBUG)

  const isOnHold = preStay?.sendStatus === PreStaySendStatusEnum.PRE_STAY_SEND_STATUS_HOLD
  return <div className="card">
    {hasDebugRole && <div className="card-header">Identifiant: {preStay?.id}</div>}
    {isOnHold && <div className="alert alert-warning">{preStay?.reason}</div>}
    {preStay && <div>
      <div className="card-body">
        <iframe style={{ height: '80vh' }} width='100%' title='poststay' src={`${getRootUrl()}stay/pre/${preStay?.id}?access_token=${token}`}></iframe>
      </div>
      <div className="card-footer">
      </div>
    </div>}
  </div>

}